import { initialiseSegment } from './segment.setup'
import { injectOneTrustScripts } from './onetrust.setup'
import cookies from '../get-cookies'

export const setupTracking = async (segmentKey, oneTrustKey, useOneTrust) => {
  (useOneTrust || cookies.get('test_onetrust_cookie') === 'true') ? injectOneTrustScripts(oneTrustKey, segmentKey) : initialiseSegment(segmentKey)
}
